import axios from "lib/axios";

export const createInvoiceApi = async (data) => {
  return await axios.post("/resident_payments/invoices", data);
};

